import React from "react";
import "./Components/CSS/App.css";

import BasicPage from "./Components/Pages/basicPage";

function App() {
  return <BasicPage />;
}

export default App;
